import React, { useEffect, useState } from "react";
import Styles from "../../styles/preview/thankyou.module.scss";
import Img_logo from "../../assets/auth/LOGO.svg";
import { getScheduleGym } from "../../services";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { adminRoutes } from "../../routers/AdminRouters";

const ThankYou = () => {
  const { gymSchedule } = useSelector((state) => state.schedule);
    const [currentDate, setCurrentDate] = useState(new Date());

  const navigate = useNavigate();
  const todaySchedule = gymSchedule?.find((schedule) => {
    const scheduleDate = new Date(schedule.date);
    return scheduleDate.toDateString() === currentDate.toDateString();
  });
  useEffect(() => {
    getScheduleGym();
  },[]);

  useEffect(() => {
    const getTimeUntilMidnight = () => {
      const now = new Date();
      const midnight = new Date();
      midnight.setHours(24, 0, 0, 0); 
      return midnight.getTime() - now.getTime();
    };

    const timeout = setTimeout(() => {
      navigate(adminRoutes.idleScreen); 
    }, getTimeUntilMidnight());

    return () => clearTimeout(timeout);
  }, [navigate]);

  return (
    <div className={Styles.thankyou_container}>
      <div className={Styles.left_section}>
        <div className={Styles.logo}>
          <img src={Img_logo} alt="Training Room Logo" />
        </div>
        <h1 className={Styles.title}>
          {" "}
          {todaySchedule ? todaySchedule.session.name : "No Session Today"}
        </h1>
        <div className={Styles.divider}></div>
        <h2 className={Styles.thank_text}>THANK YOU!</h2>
      </div>

      <div className={Styles.right_section}>
        <div
          className={Styles.info_section}
          dangerouslySetInnerHTML={{
            __html: todaySchedule?.session?.thankyou || "No Session Today",
          }}
        />
      </div>
    </div>
  );
};

export default ThankYou;
